export enum LanguageCode {
    DE = 'de',
    FR = 'fr',
    TR = 'tr',
    RO = 'ro',
    PL = 'pl',
    PT = 'pt',
    ES = 'es',
    IT = 'it',
    DA = 'da',
    SV = 'sv',
    EL = 'el',
    CS = 'cs',
}
